import script from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./WeightedTokenPill.vue?vue&type=style&index=0&id=2f1c506a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1c506a"]])

export default __exports__